import axios from "axios";

var myAxios = {};
myAxios.install = function (Vue) {
  // 请求拦截器
  // axios.interceptors.request.use(function (config) {
  //   var AccessToken = window.localStorage.getItem('accessToken');
  //   if (AccessToken) {
  //     AccessToken = "Basic R0NPMk03b1N6V0Q2VUtHVVhIMnJJeGwySUxnUDN1VWo6bTFiWTFNWVQzWmVuV1pCYVlISWI4dGZJcTNpUE8zWWI=";
  //     config.headers.common['Authorization'] = AccessToken
  //   }
  //   return config
  // }, function (err) {
  //   return Promise.reject(err)
  // });
  // // 响应拦截器
  // axios.interceptors.response.use(function (response) {
  //   if (response.data.data.token) {
  //     window.localStorage.setItem('accessToken', response.data.data.token)
  //   }
  //   return response
  // }, function (err) {
  //   return Promise.reject(error)
  // })

  Vue.prototype.$http = axios;
};

export default myAxios;



// WEBPACK FOOTER //
// ./src/assets/js/myaxios.js